module.exports = __webpack_public_path__ + "static/img/1-max.297cb1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1-max.png
// module id = QT3j
// module chunks = 36